import React, { useState } from 'react';
import PropTypes, { any } from 'prop-types';
import { useSelector } from 'react-redux';

import AddDivision from './AddDivision';
import CancelDivision from './CancelDivision';

import { isDivisionCompletelyRegistered } from '../../utils/events';
import { regStepIds, divisionRegistrationTypeIds } from '../../utils/eventConstants';
import SwitchDivisions from './SwitchDivisions';
import ChangePartner from './ChangePartner';

// supports V2 typeIds
const EditDivisionRegistration = (props) => {
    const { event, canceledDivisionIds, setCanceledDivisionIds, switchApiResponse, setSwitchApiResponse, switchTotalRefund, setSwitchTotalRefund, switchPlayer2, setSwitchPlayer2, sidebarFlow, showPreRegAlternateCopy } = props;
    const [showErrorMsg, setShowErrorMsg] = useState(false);
    const { selectedDivisionIdsByDate, players } = useSelector(({ eventProfile }) => eventProfile);
    const formateDate = (date) => new Date(date).toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
    const registeredDivisionDates = event?.eventDivisions.filter((div) => isDivisionCompletelyRegistered(div, event)).map(div => formateDate(div?.specificDivisionDateUtc));

    const divisionWithCategory = !!selectedDivisionIdsByDate?.selectedDivisions?.[0]?.divisionCategoryModel?.value;
    const showCategoryMsg = event?.preventProAmDivisionRegistrationConflicts && divisionWithCategory;
    const isSwitchFlow = sidebarFlow === regStepIds.DIVISIONS_SWITCH;

    const handleSwitchCancelStep = ({ divisionIds, totalRefund }) => {
        setCanceledDivisionIds(divisionIds);
        setSwitchTotalRefund(totalRefund);
        const player2 = event?.eventDivisions?.find(div => div.id === divisionIds[0])?.player2;
        if (player2) {
            setSwitchPlayer2(player2);
        }
        props.toStep(regStepIds.DIVISIONS_ADD);
    };

    const handleToPayment = () => {
        props.toStep(regStepIds.PAYMENT);
    };

    const distinctDivisionRegistrationTypeIds = [...new Set(event?.currentMember?.registeredDivisions?.filter((div) => !isDivisionCompletelyRegistered(div, event)).map(division => division.divisionRegistrationTypeId))];

    const onlyHasAdminAddedDivisions = distinctDivisionRegistrationTypeIds?.length === 1 &&
        distinctDivisionRegistrationTypeIds[0] === divisionRegistrationTypeIds.ADMIN_ADD_PAYMENT_REQUIRED;

    return (
        <div className="row">
            {!showPreRegAlternateCopy && !onlyHasAdminAddedDivisions && showErrorMsg && event?.preventDivisionDateRegistrationConflicts && (props.step.id === regStepIds.DIVISIONS_ADD || props.step.id === regStepIds.DIVISIONS) && !isSwitchFlow && (
                <div className="text-dark fs14 mb8 ml12">
                    This event limits registration to:
                    <li className="ml12">One division per day</li>
                    {showCategoryMsg && <li className="ml12"> Either amateur or pro divisions only</li>}
                    Based on your selection, restricted divisions are hidden. Deselect to choose a different option.
                    <div className="div div16" />
                </div>
            )}
            {!showPreRegAlternateCopy && !onlyHasAdminAddedDivisions && !showErrorMsg && showCategoryMsg && (
                <div className="text-dark fs14 mb8 ml12">
                    This event limits registration to:
                    <li className="ml12"> Either amateur or pro divisions only</li>
                    Based on your selection, restricted divisions are hidden. Deselect to choose a different option.
                    <div className="div div16" />
                </div>
            )}
            <div className="col">
                {(props.step.id === regStepIds.DIVISIONS_ADD || props.step.id === regStepIds.DIVISIONS) && (
                    <AddDivision
                        {...props}
                        registeredDivisionDates={registeredDivisionDates}
                        isEditRegisterationPage={true}
                        updateErrorMsgStatus={(value) => setShowErrorMsg(value)}
                        canceledDivisionIds={canceledDivisionIds}
                        switchPlayer2={switchPlayer2}
                        players={players}
                    />
                )}
                {props.step.id === regStepIds.DIVISIONS_SWITCH && (
                    <SwitchDivisions
                        {...props}
                        canceledDivisionIds={canceledDivisionIds}
                        switchTotalRefund={switchTotalRefund}
                        handleToPayment={handleToPayment}
                        switchApiResponse={switchApiResponse}
                        setSwitchApiResponse={setSwitchApiResponse}
                        switchPlayer2={switchPlayer2}
                    />
                )}
                {props.step.id === regStepIds.DIVISIONS_CANCEL && (
                    <CancelDivision
                        {...props}
                        handleSwitchNext={handleSwitchCancelStep}
                        canceledDivisionIds={canceledDivisionIds}
                        setSwitchPlayer2={setSwitchPlayer2}
                    />
                )}
                {props.step.id === regStepIds.CHANGE_PARTNER && (
                    <ChangePartner
                        {...props}
                        registeredDivisionDates={registeredDivisionDates}
                        isEditRegisterationPage={true}
                        updateErrorMsgStatus={(value) => setShowErrorMsg(value)}
                        canceledDivisionIds={canceledDivisionIds}
                        switchPlayer2={switchPlayer2}
                        players={players}
                    />
                )}
            </div>
        </div>
    );
};

EditDivisionRegistration.propTypes = {
    event: PropTypes.objectOf(any).isRequired,
    step: PropTypes.objectOf(any).isRequired,
    toStep: PropTypes.func.isRequired,
    canceledDivisionIds: PropTypes.arrayOf(any),
    setCanceledDivisionIds: PropTypes.func.isRequired,
    divisionFormatTypeFilter: PropTypes.number,
    switchApiResponse: PropTypes.objectOf(any),
    setSwitchApiResponse: PropTypes.func.isRequired,
    switchTotalRefund: PropTypes.number,
    setSwitchTotalRefund: PropTypes.func.isRequired,
    setDivisionFormatTypeFilter: PropTypes.func.isRequired,
    switchPlayer2: PropTypes.objectOf(any),
    setSwitchPlayer2: PropTypes.func.isRequired,
    showPreRegAlternateCopy: PropTypes.bool,
    sidebarFlow: PropTypes.string,
};

EditDivisionRegistration.defaultProps = {
    canceledDivisionIds: [],
    switchApiResponse: null,
    switchTotalRefund: 0,
    divisionFormatTypeFilter: null,
    switchPlayer2: null,
    showPreRegAlternateCopy: false,
    sidebarFlow: '',
};

export default EditDivisionRegistration;
